import { createSelector } from '@reduxjs/toolkit'
import { getWorkflowByContext } from '../../getters'

export const selectWorkflowByContext = createSelector(
  [getWorkflowByContext],
  (workflow) => workflow
)
